module.exports = __webpack_public_path__ + "img/signin.d879ef59.png";